// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9160a0fd","498":"5f0b430d","703":"1fca247b"}[chunkId] + ".chunk.js";
};